import { takeLatest, call, put } from "redux-saga/effects";
import axios from "axios";
import {
  shareArtworkRequest,
  shareArtworkSuccess,
  shareArtworkFailure,
} from "../reducer/ArtworkShareReducer";

// Worker saga
function* handleShareArtwork(action) {
  try {
    const token = localStorage.getItem("access_token");

    const response = yield call(
      axios.post,
      "https://dotconnect.dotandkey.com/api/v1/artwork/share",
      action.payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    // console.log("Share API Success Response:", response);

    // store full response
    yield put(
      shareArtworkSuccess({
        ...response.data,
        s3_key: action.payload.s3_key,
      })
    );
  } catch (err) {
    console.error("Share API Error:", err.response || err.message || err);

    yield put(
      shareArtworkFailure(
        err.response?.data?.message || err.message || "Something went wrong"
      )
    );
  }
}


// Watcher saga
function* ArtworkShareSaga() {
  yield takeLatest(shareArtworkRequest.type, handleShareArtwork);
}

// ✅ export as an array so root saga can spread
export default [ArtworkShareSaga()];
